<template>
  <section v-if="$store.getters.isAuthenticated" class="people-page">
    <b-modal
      modal-class="padding-top_modal-form"
      ignore-enforce-focus-selector=".header"
      hide-header
      hide-footer
      dialog-class="app__add-friend-modal"
      body-class="app__modal_body app__add-friend-modal_body"
      content-class="modal_content"
      id="add-friend">
      <add-friend-form/>
    </b-modal>
    <header-app
      :is-mobile="isMobile"
    />
    <main v-if="userPayoutsStatus !== 'error'" class="main">
<!--        @toggleShowProfile="showProfile = !showProfile"-->
      <transition
        :name="peopleAsideTransition"
      >
        <people-aside
          v-if="(isMobile && !showProfile) || (!isMobile)"
          :show-profile="showProfile"
          :is-mobile="isMobile"
        />
      </transition>
      <transition
        :name="humanProfileTransition"
      >
        <human-profile
          v-if="(isMobile && showProfile) || (!isMobile)"
          @toggleShowProfile="$router.push('/people')"
          :show-profile="showProfile"
          :is-mobile="isMobile"
          :are-payouts-empty="userPayouts && userPayouts.length === 0"
        />
      </transition>
    </main>
    <page-error v-if="userPayoutsStatus === 'error'" :showLang="false">
      <template #message>
        {{ $t('CP.errorOccurred') }}
      </template>
    </page-error>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { Http } from '@/http/http';
import {
  FETCH_EVENT_REQUEST,
  FETCH_EVENTS_REQUEST,
  SET_PAYOUTS_ACTIVE_USER,
  USER_PAYOUTS_REQUEST,
  USER_PAYOUT_REQUEST,
} from '@/store/events/types';
import HeaderApp from '../layouts/HeaderApp/HeaderApp';
import PeopleAside from '../layouts/PeopleAside/PeopleAside';
import HumanProfile from '../layouts/HumanProfile/HumanProfile';
import AddFriendForm from '../forms/AddFriendForm/AddFriendForm';
import PageError from '../layouts/PageError/PageError.vue';

export default {
  name: 'PeoplePage',
  components: {
    AddFriendForm,
    HumanProfile,
    PeopleAside,
    HeaderApp,
    PageError,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showProfile: false,
      peopleAsideTransition: '',
      humanProfileTransition: '',
    };
  },
  watch: {
    userPayouts() {
      if (this.$route.params.uid !== undefined) {
        this.loadContact(this.$route.params.uid);
      }
    },
    payoutsActiveUser(newUser) {
      if (newUser) {
        const newName = this.$getUserName(newUser);
        if (document.title.match(/\(.*\)/)) {
          document.title = document.title.replace(/\(.*\)/, `(${newName})`);
        } else {
          document.title += ` (${newName})`;
        }
      }
    },
  },
  computed: {
    ...mapState({
      userPayoutsStatus: (state) => state.events.userPayoutsStatus,
      userPayouts: (state) => state.events.payouts.users,
      payoutsActiveUser: (state) => state.events.payoutsActiveUser,
    }),
  },
  methods: {
    async loadInitialEventData(eventId) {
      await this.$store.dispatch(FETCH_EVENTS_REQUEST, eventId);
    },
    async loadPayouts() {
      await this.$store.dispatch(USER_PAYOUTS_REQUEST);
    },
    async loadNextEvent(eventId) {
      await this.$store.dispatch(FETCH_EVENT_REQUEST, { id: eventId });
    },
    async loadContact(uid) {
      try {
        if (uid !== undefined) {
          const user = this.getContactById(uid)
          || await this.$store.dispatch(USER_PAYOUT_REQUEST, { id: this.$route.params.uid });

          if (user) this.$store.commit(SET_PAYOUTS_ACTIVE_USER, user);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in loading payout user profile: ', e.message);
      }
    },
    getContactById(id) {
      try {
        let inEventContacts;
        if (this.$store.state.events
          && this.$store.state.events.event
          && this.$store.state.events.event.contacts) {
          inEventContacts = this.$store.state.events.event.contacts
            .find((contact) => contact.uid === +id);
        }
        let inPayouts;
        if (this.userPayouts) {
          inPayouts = this.userPayouts.find((contact) => contact.uid === +id);
        }
        const inFriends = this.$store.state.user.userContacts
          .find((contact) => contact.uid === +id);
        return inPayouts || inEventContacts || inFriends;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in contact searching: ', e);
        return '';
      }
    },
    checkIfProfileShouldOpen(route) {
      this.showProfile = false;
      if (route && route.params.uid !== undefined) {
        this.showProfile = true;
        return;
      }
      if (!route && this.$route.params.uid !== undefined) {
        this.showProfile = true;
      }
    },
    setTransitions() {
      this.peopleAsideTransition = 'peopleAsideTransition';
      this.humanProfileTransition = 'humanProfileTransition';
    },
  },
  mounted() {
    this.loadInitialEventData(this.$route.params.uid);
    this.loadPayouts();
    this.checkIfProfileShouldOpen();
    this.setTransitions();
  },
  destroyed() {
    Http.abortRequest();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.uid !== undefined) this.loadContact(to.params.uid);
    if (to.params.id !== undefined) {
      this.loadNextEvent(to.params.id);
    }
    this.checkIfProfileShouldOpen(to);
    next();
  },
};
</script>

<style lang="scss" scoped>
  .people-page {
    padding-top: 45px;
    min-height: 100%;
    height: 100%;
    flex: 1 1 100%;
  }
  .main {
    min-height: 100%;
    height: calc(100% - 45px);
    display: flex;
    flex-direction: row;
  }
  .error-message {
    color: var(--error-red);
    min-height: 100%;
    background: white;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .peopleAsideTransition-enter-active {
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: .3s all;
  }
  .peopleAsideTransition-leave-active {
    transition: 0s all;
  }
  .peopleAsideTransition-enter, .peopleAsideTransition-leave-to {
    opacity: 0;
  }

  .humanProfileTransition-enter-active {
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: .3s all;
  }
  .humanProfileTransition-leave-active {
    transition: 0s all;
  }
  .humanProfileTransition-enter, .humanProfileTransition-leave-to {
    opacity: 0;
  }
</style>
